import { sendTrackingEvent } from 'actions/workflows/workflows';
import { isCustomFetchErrorObject } from 'api/customFetch';
import { useAppDispatch, useAppSelector } from 'hooks';
import { useEffect } from 'react';
import {
  selectError,
  selectConversationId,
  selectIsBuilderPreview,
} from 'reducers/workflows';

export function useErrorBannerTrackingEvent(): void {
  const dispatch = useAppDispatch();
  const error = useAppSelector(selectError);
  const conversationId = useAppSelector(selectConversationId);
  const isPreview = useAppSelector(selectIsBuilderPreview);

  useEffect(() => {
    if (!error) {
      return;
    }

    let errorMessage: string;
    try {
      errorMessage = typeof error === 'string' ? error : error.message;
    } catch {
      errorMessage = `Failed to parse error message when sending tracking event. Error: ${error}`;
    }

    dispatch(
      sendTrackingEvent({
        conversation_id: conversationId,
        error_message: errorMessage,
        event_type: 'widget-error-banner-visible',
        is_preview: isPreview,

        ...(isCustomFetchErrorObject(error)
          ? {
              internalTraceId: error.internalTraceId,
              method: error.method,
              response_data: error.response_data,
              status: error.status,
              url: error.url,
            }
          : {}),
      }),
    );
  }, [conversationId, dispatch, error, isPreview]);
}
